<template>
  <div class="preview-block">
    <transition name="fade" mode="out-in">
      <div v-if="nbCredits <= 50" class="credits-block">
        <div class="left-block">
          <div class="credits-selected">
            <span>{{ nbCredits }}</span>
            évaluation{{ nbCredits > 1 ? "s" : "" }} sélectionnée{{
              nbCredits > 1 ? "s" : ""
            }}
          </div>
          <div class="gift-block">
            dont
            <span>{{ giftedCredit }}</span>
            évaluation{{ giftedCredit > 1 ? "s" : "" }} offerte{{
              giftedCredit > 1 ? "s" : ""
            }}
          </div>
          <div class="final-price">
            <span class="big">
              {{ totalPrice }}<span>€</span>
            </span>
          </div>
        </div>
        <div class="right-block">
          <h4>L’offre idéale pour découvrir Yuzu</h4>
          <div class="dots-container">
            <div
              class="dots-item"
              v-for="(item, index) in state.dots"
              :key="index"
            >
              <div class="round-icon">
                <i class="bi bi-check" />
              </div>
              {{ item }}
            </div>
          </div>
          <span class="info">*Les prix indiqués sont calculés hors taxes.</span>
        </div>
      </div>
      <div v-else class="more-credits-block">
        <div class="title-block">
          <h3>Vous avez besoin de plus d’évaluations ?</h3>
          <p>
            Contactez notre équipe pour bénéficier d’un accompagnement
            personnalisé pour votre organisation ou votre cabinet.
          </p>
        </div>
        <div class="items-block">
          <div class="item">
            <img src="@/assets/images/illustration/payment/icon-chart.svg" />
            Tarif préférentiel
          </div>
          <div class="item">
            <img src="@/assets/images/illustration/payment/icon-profil.svg" />
            Nombre d’utilisateurs illimité
          </div>
          <div class="item">
            <img src="@/assets/images/illustration/payment/icon-star.svg" />
            Accès illimité à toutes les fonctionnalités
          </div>
        </div>
        <Button
          class="primary"
          label="Prendre contact avec l'équipe Yuzu"
          @click="emits('close'), $router.push({ name: 'contact' })"
        />
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive } from "vue";

import { Pricing } from "../SliderPricing.vue";

const emits = defineEmits(["close"]);

const props = defineProps({
  pricing: {
    type: Array,
    required: true,
  },
  nbCredits: {
    type: Number,
    required: true,
  },
});

const state = reactive({
  dots: [
    "1 utilisateur",
    "Accès à toutes les fonctionnalités",
    "Support technique via chat",
  ],
});

const currentPricing = computed<Pricing | undefined>(() => {
  return (props.pricing as Pricing[]).find((elt) => elt.amount === props.nbCredits);
});

const giftedCredit = computed(() => {
  return currentPricing.value?.gift || 0;
});

const totalPrice = computed(() => {
  return currentPricing.value?.price || 0;
});
</script>
